var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-page"},[_c('div',[_c('InputOTP',{attrs:{"type":2},on:{"submitValidateOTP":_vm.submitValidateOTP,"clickChangePhone":_vm.clickChangePhone}})],1),_c('ModalError',{ref:"modalError",attrs:{"text":_vm.successMessage}}),_c('ModalAlert',{ref:"modalAlert",attrs:{"text":_vm.successMessage},on:{"hide":_vm.hide}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }